import Moment from 'moment'
import Shipment from "@/domain/Shipment";
import InvoiceMemberDetails from "@/domain/InvoiceMemberDetails";
import Invoice from "@/domain/Invoice";
import Order from "@/domain/order/Order"
import OrderItem from '@/domain/order/OrderItem'
import * as OrderExecutorCreateInvoiceStrategies from '@/enum/OrderExecutorCreateInvoiceStrategyType'
import * as OrderExecutorEditStrategies from '@/enum/OrderExecutorEditStrategyType'
import * as OrderShipmentDeliveryDateStrategies from '@/enum/OrderShipmentDeliveryDateStrategyType'
import * as OrderShipmentDateMethodStrategies from '@/enum/OrderShipmentDateMethodStrategyType'
import * as OrderProductNameDefineMethodStrategies from '@/enum/OrderProductNameDefineMethodStrategyType'
import * as OrderContractDefineMethodStrategies from '@/enum/OrderContractDefineMethodStrategyType'
import * as OrderItemQuantityLimitStrategies from '@/enum/OrderItemQuantityLimitStrategyType'
import _ from 'underscore'
import OrderInfo from "@/domain/order/OrderInfo";
import InvoiceItemCatalog from "@/domain/invoice/InvoiceItemCatalog";
import ShipmentInfo from "@/domain/ShipmentInfo";
import ShipmentItem from "@/domain/ShipmentItem";
import InvoiceItem from "@/domain/InvoiceItem";
import InvoiceInfo from "@/domain/InvoiceInfo";
import ReturnOrderInfo from "@/domain/return-order/ReturnOrderInfo";
import ReturnOrder from "@/domain/return-order/ReturnOrder";
import ReturnOrderItem from "@/domain/return-order/ReturnOrderItem";
import ReturnShipmentItem from "@/domain/return-shipment/ReturnShipmentItem";
import ReturnShipment from "@/domain/return-shipment/ReturnShipment";
import ReturnShipmentInfo from "@/domain/return-shipment/ReturnShipmentInfo";

let mapOrderExecutorCreateInvoiceStrategy = (code) => {
    let keys = _.keys(OrderExecutorCreateInvoiceStrategies)
    let codeKey = _.find(keys, key => {
        return OrderExecutorCreateInvoiceStrategies[key].id === code;
    })

    return OrderExecutorCreateInvoiceStrategies[codeKey];
}

let mapOrderExecutorEditStrategy = (code) => {
    let keys = _.keys(OrderExecutorEditStrategies)
    let codeKey = _.find(keys, key => {
        return OrderExecutorEditStrategies[key].id === code;
    })

    return OrderExecutorEditStrategies[codeKey];
}

let mapOrderShipmentDeliveryDateStrategy = (code) => {
    let keys = _.keys(OrderShipmentDeliveryDateStrategies)
    let codeKey = _.find(keys, key => {
        return OrderShipmentDeliveryDateStrategies[key].id === code;
    })

    return OrderShipmentDeliveryDateStrategies[codeKey];
}

let mapOrderShipmentDateMethodStrategy = (code) => {
    let keys = _.keys(OrderShipmentDateMethodStrategies)
    let codeKey = _.find(keys, key => {
        return OrderShipmentDateMethodStrategies[key].id === code;
    })

    return OrderShipmentDateMethodStrategies[codeKey];
}

let mapOrderProductNameDefineMethodStrategy = (code) => {
    let keys = _.keys(OrderProductNameDefineMethodStrategies)
    let codeKey = _.find(keys, key => {
        return OrderProductNameDefineMethodStrategies[key].id === code;
    })

    return OrderProductNameDefineMethodStrategies[codeKey];
}

let mapOrderContractDefineMethodStrategy = (code) => {
    let keys = _.keys(OrderContractDefineMethodStrategies)
    let codeKey = _.find(keys, key => {
        return OrderContractDefineMethodStrategies[key].id === code;
    })

    return OrderContractDefineMethodStrategies[codeKey];
}

let mapOrderItemQuantityLimitStrategy = (code) => {
    let keys = _.keys(OrderItemQuantityLimitStrategies)
    let codeKey = _.find(keys, key => {
        return OrderItemQuantityLimitStrategies[key].id === code;
    })

    return OrderItemQuantityLimitStrategies[codeKey];
}



let mapOrderItem = orderItemViewModel => {
    if (orderItemViewModel) {
        let orderItem = new OrderItem()

        orderItem.id = orderItemViewModel.Id
        orderItem.product = orderItemViewModel.Product
        orderItem.productCode = orderItemViewModel.ProductCode
        orderItem.measurement = orderItemViewModel.Measurement
        orderItem.price = orderItemViewModel.Price
        orderItem.quantity = orderItemViewModel.Quantity
        orderItem.quantityLeft = orderItemViewModel.QuantityLeft
        orderItem.ndsRate = orderItemViewModel.NdsRate
        orderItem.customerCode = orderItemViewModel.CustomerCode
        orderItem.customerSystemId = orderItemViewModel.CustomerSystemItemId
        orderItem.customerShipmentItemId = orderItemViewModel.CustomerShipmentItemId
        orderItem.catalogCode = orderItemViewModel.CatalogCode

        orderItem.recalculateComputes()

        return orderItem
    }

    return null
}

let mapOrder = orderViewModel => {
    if (orderViewModel) {
        let order = new Order()

        order.id = orderViewModel.Id
        order.executorEditStrategy = mapOrderExecutorEditStrategy(orderViewModel.ExecutorEditStrategy)
        order.shipmentDeliveryDateStrategy = mapOrderShipmentDeliveryDateStrategy(orderViewModel.ShipmentDeliveryDateStrategy)
        order.executorCreateInvoiceStrategy = mapOrderExecutorCreateInvoiceStrategy(orderViewModel.ExecutorCreateInvoiceStrategy)
        order.shipmentDateMethodStrategy = mapOrderShipmentDateMethodStrategy(orderViewModel.OrderShipmentDateMethodStrategy)
        order.productNameDefineMethodStrategy = mapOrderProductNameDefineMethodStrategy(orderViewModel.OrderProductNameDefineMethodStrategy)
        order.contractDefineMethodStrategy = mapOrderContractDefineMethodStrategy(orderViewModel.OrderContractDefineMethodStrategy)
        order.itemQuantityLimitStrategy = mapOrderItemQuantityLimitStrategy(orderViewModel.OrderItemQuantityLimitStrategy)
        order.customerInn = orderViewModel.CustomerInn;
        order.customerName = orderViewModel.CustomerName;
        order.executorInn = orderViewModel.ExecutorInn;
        order.executorName = orderViewModel.ExecutorName;
        order.number = orderViewModel.Number
        order.date = Moment(orderViewModel.Date);
        order.contractNumber = orderViewModel.ContractNumber;
        order.contractDate = Moment(orderViewModel.ContractDate);
        order.expiresOn = Moment(orderViewModel.ExpiresOn);
        order.deliveryAddress = orderViewModel.DeliveryAddress;
        order.branch = orderViewModel.BranchId;
        order.createdOn = Moment(orderViewModel.CreatedOn);
        order.isCustomerApproved = orderViewModel.IsCustomerApproved;
        order.customerApprovedOn = orderViewModel.CustomerApprovedOn ? Moment(orderViewModel.CustomerApprovedOn) : null;
        order.isExecutorApproved = orderViewModel.IsExecutorApproved;
        order.executorApprovedOn = orderViewModel.ExecutorApprovedOn ? Moment(orderViewModel.ExecutorApprovedOn) : null;
        order.isExecutorDeclined = orderViewModel.IsExecutorDeclined;
        order.executorDeclinedOn = orderViewModel.ExecutorDeclinedOn ? Moment(orderViewModel.ExecutorDeclinedOn) : null;
        order.isReturn = orderViewModel.IsReturn;
        order.returnNumber = orderViewModel.ReturnNumber;
        order.returnDate = orderViewModel.ReturnDate ? Moment(orderViewModel.ReturnDate) : null;
        order.returnInvoiceId = orderViewModel.ReturnInvoiceId;
        order.returnInvoiceNumber = orderViewModel.ReturnInvoiceNumber;
        order.returnInvoiceDate = orderViewModel.ReturnInvoiceDate ? Moment(orderViewModel.ReturnInvoiceDate) : null;
        order.isReturnInvoiceExecutorApproved = orderViewModel.IsReturnInvoiceExecutorApproved;
        order.isReturnInvoiceCustomerApproved = orderViewModel.IsReturnInvoiceCustomerApproved;
        order.isStopped = orderViewModel.IsStopped;
        order.stoppedOn = orderViewModel.StoppedOn ? Moment(orderViewModel.StoppedOn) : null;
        order.status = orderViewModel.Status
        order.customerSystemId = orderViewModel.CustomerSystemId
        order.customerShipmentId = orderViewModel.CustomerShipmentId

        return order
    }

    return null
}

let mapOrderInfo = orderViewModel => {
    if (orderViewModel) {
        let orderInfo = new OrderInfo()

        orderInfo.id = orderViewModel.Id
        orderInfo.customerSystemId = orderViewModel.CustomerSystemId
        orderInfo.customerShipmentId = orderViewModel.CustomerShipmentId
        orderInfo.status = orderViewModel.Status
        orderInfo.executorEditStrategy = mapOrderExecutorEditStrategy(orderViewModel.ExecutorEditStrategy)
        orderInfo.shipmentDeliveryDateStrategy = mapOrderShipmentDeliveryDateStrategy(orderViewModel.ShipmentDeliveryDateStrategy)
        orderInfo.executorCreateInvoiceStrategy = mapOrderExecutorCreateInvoiceStrategy(orderViewModel.ExecutorCreateInvoiceStrategy)
        orderInfo.shipmentDateMethodStrategy = mapOrderShipmentDateMethodStrategy(orderViewModel.OrderShipmentDateMethodStrategy)
        orderInfo.productNameDefineMethodStrategy = mapOrderProductNameDefineMethodStrategy(orderViewModel.OrderProductNameDefineMethodStrategy)
        orderInfo.contractDefineMethodStrategy = mapOrderContractDefineMethodStrategy(orderViewModel.OrderContractDefineMethodStrategy)
        orderInfo.itemQuantityLimitStrategy = mapOrderItemQuantityLimitStrategy(orderViewModel.OrderItemQuantityLimitStrategy)
        orderInfo.customerInn = orderViewModel.CustomerInn;
        orderInfo.customerName = orderViewModel.CustomerName;
        orderInfo.executorInn = orderViewModel.ExecutorInn;
        orderInfo.executorName = orderViewModel.ExecutorName;
        orderInfo.number = orderViewModel.Number
        orderInfo.date = Moment(orderViewModel.Date);
        orderInfo.contractNumber = orderViewModel.ContractNumber;
        orderInfo.contractDate = Moment(orderViewModel.ContractDate);
        orderInfo.expiresOn = Moment(orderViewModel.ExpiresOn);
        orderInfo.deliveryAddress = orderViewModel.DeliveryAddress;
        orderInfo.branch = orderViewModel.BranchId;
        orderInfo.createdOn = Moment(orderViewModel.CreatedOn);
        orderInfo.isCustomerApproved = orderViewModel.IsCustomerApproved;
        orderInfo.customerApprovedOn = orderViewModel.CustomerApprovedOn ? Moment(orderViewModel.CustomerApprovedOn) : null;
        orderInfo.isExecutorApproved = orderViewModel.IsExecutorApproved;
        orderInfo.executorApprovedOn = orderViewModel.ExecutorApprovedOn ? Moment(orderViewModel.ExecutorApprovedOn) : null;
        orderInfo.isExecutorDeclined = orderViewModel.IsExecutorDeclined;
        orderInfo.executorDeclinedOn = orderViewModel.ExecutorDeclinedOn ? Moment(orderViewModel.ExecutorDeclinedOn) : null;
        orderInfo.isReturn = orderViewModel.IsReturn;
        orderInfo.returnNumber = orderViewModel.ReturnNumber;
        orderInfo.returnDate = orderViewModel.ReturnDate ? Moment(orderViewModel.ReturnDate) : null;
        orderInfo.returnInvoiceId = orderViewModel.ReturnInvoiceId;
        orderInfo.returnInvoiceNumber = orderViewModel.ReturnInvoiceNumber;
        orderInfo.returnInvoiceDate = orderViewModel.ReturnInvoiceDate ? Moment(orderViewModel.ReturnInvoiceDate) : null;
        orderInfo.isReturnInvoiceExecutorApproved = orderViewModel.IsReturnInvoiceExecutorApproved;
        orderInfo.isReturnInvoiceCustomerApproved = orderViewModel.IsReturnInvoiceCustomerApproved;
        orderInfo.isStopped = orderViewModel.IsStopped;
        orderInfo.stoppedOn = orderViewModel.StoppedOn ? Moment(orderViewModel.StoppedOn) : null;
        orderInfo.items = _.map(orderViewModel.Items, orderItemViewModel => {
            return mapOrderItem(orderItemViewModel)
        })

        return orderInfo
    }

    return null
}



let mapShipmentItem = item => {
    let shipmentItem = new ShipmentItem()
    shipmentItem.id = item.Id
    shipmentItem.product = item.Product
    shipmentItem.customerCode = item.CustomerCode
    shipmentItem.catalogCode = item.CatalogCode
    shipmentItem.measurement = item.Measurement
    shipmentItem.quantity = item.Quantity
    shipmentItem.price = item.Price
    shipmentItem.total = item.Total
    shipmentItem.ndsRate = item.NdsRate
    shipmentItem.ndsValue = item.NdsValue
    shipmentItem.totalWithNds = item.TotalWithNds
    shipmentItem.orderItem = item.OrderItem ? mapOrderItem(item.OrderItem) : null

    return shipmentItem
}

let mapShipment = shipmentViewModel => {
    if (shipmentViewModel) {
        let shipment = new Shipment()

        shipment.id = shipmentViewModel.Id
        shipment.order = shipmentViewModel.Order ? mapOrder(shipmentViewModel.Order) : null
        shipment.status = shipmentViewModel.Status
        shipment.number = shipmentViewModel.Number
        shipment.date = shipmentViewModel.Date ? Moment(shipmentViewModel.Date.substr(0, 10), 'YYYY-MM-DD') : null
        shipment.waybillNumber = shipmentViewModel.WaypathBillNumber
        shipment.waybillDate = shipmentViewModel.WaypathBillDate ? Moment(shipmentViewModel.WaypathBillDate.substr(0, 10), 'YYYY-MM-DD') : null
        shipment.contractNumber = shipmentViewModel.ContractNumber
        shipment.contractDate = shipmentViewModel.ContractDate ? Moment(shipmentViewModel.ContractDate.substr(0, 10), 'YYYY-MM-DD') : null
        shipment.createdOn = shipmentViewModel.CreatedOn ? Moment(shipmentViewModel.CreatedOn) : null
        shipment.isAccepted = shipmentViewModel.IsAccepted
        shipment.acceptedOn = shipmentViewModel.AcceptedOn ? Moment(shipmentViewModel.AcceptedOn) : null
        shipment.isDeclined = shipmentViewModel.IsDeclined
        shipment.lastDeclinedOn = shipmentViewModel.LastDeclinedOn ? Moment(shipmentViewModel.LastDeclinedOn) : null
        shipment.total = shipmentViewModel.Total
        shipment.totalInWords = shipmentViewModel.TotalInWords
        shipment.customerInn = shipmentViewModel.CustomerInn
        shipment.customerName = shipmentViewModel.CustomerName
        shipment.consigneeInn = shipmentViewModel.ConsigneeInn
        shipment.consigneeName = shipmentViewModel.ConsigneeName
        shipment.deliveryAddress = shipmentViewModel.DeliveryAddress
        shipment.loadingAddress = shipmentViewModel.LoadingAddress
        shipment.driverName = shipmentViewModel.DriverName
        shipment.carSerial = shipmentViewModel.CarSerialNumber
        shipment.carModel = shipmentViewModel.CarModel
        shipment.isTrailer = shipmentViewModel.IsTrailer
        shipment.isSemiTrailer = shipmentViewModel.IsSemiTrailer
        shipment.trailerSerial = shipmentViewModel.TrailerSerialNumber
        shipment.trailerModel = shipmentViewModel.TrailerModel
        shipment.deliveryDateTime = shipmentViewModel.DeliveryDateTime ? Moment(shipmentViewModel.DeliveryDateTime) : null

        shipment.invoices = shipmentViewModel.Invoices.map(i => {
            return mapInvoice(i)
        })

        return shipment
    }

    return null
}

let mapShipmentInfo = shipmentViewModel => {
    if (shipmentViewModel) {
        let shipment = new ShipmentInfo()

        shipment.id = shipmentViewModel.Id
        shipment.order = shipmentViewModel.Order ? mapOrder(shipmentViewModel.Order) : null
        shipment.status = shipmentViewModel.Status
        shipment.number = shipmentViewModel.Number
        shipment.date = shipmentViewModel.Date ? Moment(shipmentViewModel.Date.substr(0, 10), 'YYYY-MM-DD') : null
        shipment.waybillNumber = shipmentViewModel.WaypathBillNumber
        shipment.waybillDate = shipmentViewModel.WaypathBillDate ? Moment(shipmentViewModel.WaypathBillDate.substr(0, 10), 'YYYY-MM-DD') : null
        shipment.contractNumber = shipmentViewModel.ContractNumber
        shipment.contractDate = shipmentViewModel.ContractDate ? Moment(shipmentViewModel.ContractDate.substr(0, 10), 'YYYY-MM-DD') : null
        shipment.createdOn = shipmentViewModel.CreatedOn ? Moment(shipmentViewModel.CreatedOn) : null
        shipment.isAccepted = shipmentViewModel.IsAccepted
        shipment.acceptedOn = shipmentViewModel.AcceptedOn ? Moment(shipmentViewModel.AcceptedOn) : null
        shipment.isDeclined = shipmentViewModel.IsDeclined
        shipment.lastDeclinedOn = shipmentViewModel.LastDeclinedOn ? Moment(shipmentViewModel.LastDeclinedOn) : null
        shipment.total = shipmentViewModel.Total
        shipment.totalInWords = shipmentViewModel.TotalInWords
        shipment.customerInn = shipmentViewModel.CustomerInn
        shipment.customerName = shipmentViewModel.CustomerName
        shipment.consigneeInn = shipmentViewModel.ConsigneeInn
        shipment.consigneeName = shipmentViewModel.ConsigneeName
        shipment.deliveryAddress = shipmentViewModel.DeliveryAddress
        shipment.loadingAddress = shipmentViewModel.LoadingAddress
        shipment.driverName = shipmentViewModel.DriverName
        shipment.carSerial = shipmentViewModel.CarSerialNumber
        shipment.carModel = shipmentViewModel.CarModel
        shipment.isTrailer = shipmentViewModel.IsTrailer
        shipment.isSemiTrailer = shipmentViewModel.IsSemiTrailer
        shipment.trailerSerial = shipmentViewModel.TrailerSerialNumber
        shipment.trailerModel = shipmentViewModel.TrailerModel
        shipment.deliveryDateTime = shipmentViewModel.DeliveryDateTime ? Moment(shipmentViewModel.DeliveryDateTime) : null
        shipment.items = shipmentViewModel.Items.map(item => {
            return mapShipmentItem(item)
        })

        shipment.invoices = shipmentViewModel.Invoices.map(i => {
            return mapInvoice(i)
        })

        return shipment
    }

    return null
}



let mapInvoiceItem = item => {
    let invoiceItem = new InvoiceItem()

    invoiceItem.id = item.Id
    invoiceItem.measurement = item.Measurement
    invoiceItem.measurementCode = item.MeasurementCode
    invoiceItem.ndsRate = item.NdsRate
    invoiceItem.ndsValue = item.NdsValue
    invoiceItem.price = item.Price
    invoiceItem.product = item.Product
    invoiceItem.quantity = item.Quantity
    invoiceItem.total = item.Total
    invoiceItem.catalogCode = item.CatalogCode
    invoiceItem.catalogName = item.CatalogName
    invoiceItem.totalWithNds = item.TotalWithNds
    invoiceItem.barcode = item.Barcode
    invoiceItem.lgota = item.LgotaId
    invoiceItem.shipmentItem = item.ShipmentItem ? mapShipmentItem(item.ShipmentItem) : null

    return invoiceItem
}

let mapInvoice = invoiceViewModel => {
    if (invoiceViewModel) {
        let invoice = new Invoice()

        invoice.id = invoiceViewModel.Id
        invoice.number = invoiceViewModel.Number
        invoice.status = invoiceViewModel.Status
        invoice.date = invoiceViewModel.Date ? Moment(invoiceViewModel.Date.substr(0, 10), 'YYYY-MM-DD') : null
        invoice.contractNumber = invoiceViewModel.ContractNumber
        invoice.contractDate = invoiceViewModel.ContractDate ? Moment(invoiceViewModel.ContractDate.substr(0, 10), 'YYYY-MM-DD') : null
        invoice.createdOn = invoiceViewModel.CreatedOn ? Moment(invoiceViewModel.CreatedOn) : null
        invoice.isCustomerApproved = invoiceViewModel.IsCustomerApproved
        invoice.customerApprovedOn = invoiceViewModel.CustomerApprovedOn ? Moment(invoiceViewModel.CustomerApprovedOn) : null
        invoice.isExecutorApproved = invoiceViewModel.IsExecutorApproved
        invoice.executorApprovedOn = invoiceViewModel.ExecutorApprovedOn ? Moment(invoiceViewModel.ExecutorApprovedOn) : null
        invoice.executorDetails = mapInvoiceMember(invoiceViewModel.ExecutorDetail)
        invoice.customerDetails = mapInvoiceMember(invoiceViewModel.CustomerDetail)
        invoice.total = invoiceViewModel.Total
        invoice.totalInWords = invoiceViewModel.TotalInWords
        invoice.executorDirector = invoiceViewModel.ExecutorDirector
        invoice.executorAccountant = invoiceViewModel.ExecutorAcccountant
        invoice.executorReleaser = invoiceViewModel.ExecutorReleaser
        invoice.customerProxyNumber = invoiceViewModel.CustomerProxyNumber
        invoice.customerProxyDate = invoiceViewModel.CustomerProxyDate ? Moment(invoiceViewModel.CustomerProxyDate.substr(0, 10), 'YYYY-MM-DD') : null
        invoice.customerProxyName = invoiceViewModel.CustomerProxyName
        invoice.shipment = invoiceViewModel.Shipment ? mapShipment(invoiceViewModel.Shipment) : null

        return invoice
    }

    return null
}

let mapInvoiceInfo = invoiceViewModel => {
    if (invoiceViewModel) {
        let invoice = new InvoiceInfo()

        invoice.id = invoiceViewModel.Id
        invoice.number = invoiceViewModel.Number
        invoice.status = invoiceViewModel.Status
        invoice.date = invoiceViewModel.Date ? Moment(invoiceViewModel.Date.substr(0, 10), 'YYYY-MM-DD') : null
        invoice.contractNumber = invoiceViewModel.ContractNumber
        invoice.contractDate = invoiceViewModel.ContractDate ? Moment(invoiceViewModel.ContractDate.substr(0, 10), 'YYYY-MM-DD') : null
        invoice.createdOn = invoiceViewModel.CreatedOn ? Moment(invoiceViewModel.CreatedOn) : null
        invoice.isCustomerApproved = invoiceViewModel.IsCustomerApproved
        invoice.customerApprovedOn = invoiceViewModel.CustomerApprovedOn ? Moment(invoiceViewModel.CustomerApprovedOn) : null
        invoice.isExecutorApproved = invoiceViewModel.IsExecutorApproved
        invoice.executorApprovedOn = invoiceViewModel.ExecutorApprovedOn ? Moment(invoiceViewModel.ExecutorApprovedOn) : null
        invoice.executorDetails = mapInvoiceMember(invoiceViewModel.ExecutorDetail)
        invoice.customerDetails = mapInvoiceMember(invoiceViewModel.CustomerDetail)
        invoice.total = invoiceViewModel.Total
        invoice.totalInWords = invoiceViewModel.TotalInWords
        invoice.executorDirector = invoiceViewModel.ExecutorDirector
        invoice.executorAccountant = invoiceViewModel.ExecutorAcccountant
        invoice.executorReleaser = invoiceViewModel.ExecutorReleaser
        invoice.customerProxyNumber = invoiceViewModel.CustomerProxyNumber
        invoice.customerProxyDate = invoiceViewModel.CustomerProxyDate ? Moment(invoiceViewModel.CustomerProxyDate.substr(0, 10), 'YYYY-MM-DD') : null
        invoice.customerProxyName = invoiceViewModel.CustomerProxyName
        invoice.shipment = invoiceViewModel.Shipment ? mapShipment(invoiceViewModel.Shipment) : null
        invoice.items = invoiceViewModel.Items.map(item => {
            return mapInvoiceItem(item)
        })

        return invoice
    }

    return null
}

let mapInvoiceMember = invoiceMemberDetailsViewModel => {
    if (invoiceMemberDetailsViewModel) {
        let invoiceMember = new InvoiceMemberDetails()

        invoiceMember.inn = invoiceMemberDetailsViewModel.Inn
        invoiceMember.name = invoiceMemberDetailsViewModel.Name
        invoiceMember.address = invoiceMemberDetailsViewModel.Address
        invoiceMember.phone = invoiceMemberDetailsViewModel.Phone
        invoiceMember.bankAccountNumber = invoiceMemberDetailsViewModel.BankAccountNumber
        invoiceMember.bankName = invoiceMemberDetailsViewModel.BankName
        invoiceMember.bankMfo = invoiceMemberDetailsViewModel.BankMfo
        invoiceMember.oked = invoiceMemberDetailsViewModel.Oked
        invoiceMember.okonx = invoiceMemberDetailsViewModel.Okonx
        invoiceMember.ndsRegistrationCode = invoiceMemberDetailsViewModel.NdsRegistrationCode

        return invoiceMember
    }

    return null
}



let mapReturnOrderItem = orderItemViewModel => {
    if (orderItemViewModel) {
        let orderItem = new ReturnOrderItem()

        orderItem.id = orderItemViewModel.Id
        orderItem.product = orderItemViewModel.Product
        orderItem.productCode = orderItemViewModel.ProductCode
        orderItem.measurement = orderItemViewModel.Measurement
        orderItem.price = orderItemViewModel.Price
        orderItem.quantity = orderItemViewModel.Quantity
        orderItem.quantityLeft = orderItemViewModel.QuantityLeft
        orderItem.ndsRate = orderItemViewModel.NdsRate
        orderItem.customerCode = orderItemViewModel.CustomerCode
        orderItem.customerSystemId = orderItemViewModel.CustomerSystemItemId
        orderItem.customerShipmentItemId = orderItemViewModel.CustomerShipmentItemId
        orderItem.catalogCode = orderItemViewModel.CatalogCode

        orderItem.recalculateComputes()

        return orderItem
    }

    return null
}

let mapReturnOrder = orderViewModel => {
    if (orderViewModel) {
        let order = new ReturnOrder()

        order.id = orderViewModel.Id
        order.executorEditStrategy = mapOrderExecutorEditStrategy(orderViewModel.ExecutorEditStrategy)
        order.shipmentDeliveryDateStrategy = mapOrderShipmentDeliveryDateStrategy(orderViewModel.ShipmentDeliveryDateStrategy)
        order.executorCreateInvoiceStrategy = mapOrderExecutorCreateInvoiceStrategy(orderViewModel.ExecutorCreateInvoiceStrategy)
        order.shipmentDateMethodStrategy = mapOrderShipmentDateMethodStrategy(orderViewModel.OrderShipmentDateMethodStrategy)
        order.productNameDefineMethodStrategy = mapOrderProductNameDefineMethodStrategy(orderViewModel.OrderProductNameDefineMethodStrategy)
        order.contractDefineMethodStrategy = mapOrderContractDefineMethodStrategy(orderViewModel.OrderContractDefineMethodStrategy)
        order.itemQuantityLimitStrategy = mapOrderItemQuantityLimitStrategy(orderViewModel.OrderItemQuantityLimitStrategy)
        order.customerInn = orderViewModel.CustomerInn;
        order.customerName = orderViewModel.CustomerName;
        order.executorInn = orderViewModel.ExecutorInn;
        order.executorName = orderViewModel.ExecutorName;
        order.number = orderViewModel.Number
        order.date = Moment(orderViewModel.Date);
        order.contractNumber = orderViewModel.ContractNumber;
        order.contractDate = Moment(orderViewModel.ContractDate);
        order.expiresOn = Moment(orderViewModel.ExpiresOn);
        order.deliveryAddress = orderViewModel.DeliveryAddress;
        order.branch = orderViewModel.BranchId;
        order.createdOn = Moment(orderViewModel.CreatedOn);
        order.isCustomerApproved = orderViewModel.IsCustomerApproved;
        order.customerApprovedOn = orderViewModel.CustomerApprovedOn ? Moment(orderViewModel.CustomerApprovedOn) : null;
        order.isExecutorApproved = orderViewModel.IsExecutorApproved;
        order.executorApprovedOn = orderViewModel.ExecutorApprovedOn ? Moment(orderViewModel.ExecutorApprovedOn) : null;
        order.isExecutorDeclined = orderViewModel.IsExecutorDeclined;
        order.executorDeclinedOn = orderViewModel.ExecutorDeclinedOn ? Moment(orderViewModel.ExecutorDeclinedOn) : null;
        order.isReturn = orderViewModel.IsReturn;
        order.returnNumber = orderViewModel.ReturnNumber;
        order.returnDate = orderViewModel.ReturnDate ? Moment(orderViewModel.ReturnDate) : null;
        order.returnInvoiceId = orderViewModel.ReturnInvoiceId;
        order.returnInvoiceNumber = orderViewModel.ReturnInvoiceNumber;
        order.returnInvoiceDate = orderViewModel.ReturnInvoiceDate ? Moment(orderViewModel.ReturnInvoiceDate) : null;
        order.isReturnInvoiceExecutorApproved = orderViewModel.IsReturnInvoiceExecutorApproved;
        order.isReturnInvoiceCustomerApproved = orderViewModel.IsReturnInvoiceCustomerApproved;
        order.isStopped = orderViewModel.IsStopped;
        order.stoppedOn = orderViewModel.StoppedOn ? Moment(orderViewModel.StoppedOn) : null;
        order.status = orderViewModel.Status
        order.customerSystemId = orderViewModel.CustomerSystemId
        order.customerShipmentId = orderViewModel.CustomerShipmentId

        return order
    }

    return null
}

let mapReturnOrderInfo = orderViewModel => {
    if (orderViewModel) {
        let orderInfo = new ReturnOrderInfo()

        orderInfo.id = orderViewModel.Id
        orderInfo.customerSystemId = orderViewModel.CustomerSystemId
        orderInfo.customerShipmentId = orderViewModel.CustomerShipmentId
        orderInfo.status = orderViewModel.Status
        orderInfo.executorEditStrategy = mapOrderExecutorEditStrategy(orderViewModel.ExecutorEditStrategy)
        orderInfo.shipmentDeliveryDateStrategy = mapOrderShipmentDeliveryDateStrategy(orderViewModel.ShipmentDeliveryDateStrategy)
        orderInfo.executorCreateInvoiceStrategy = mapOrderExecutorCreateInvoiceStrategy(orderViewModel.ExecutorCreateInvoiceStrategy)
        orderInfo.shipmentDateMethodStrategy = mapOrderShipmentDateMethodStrategy(orderViewModel.OrderShipmentDateMethodStrategy)
        orderInfo.productNameDefineMethodStrategy = mapOrderProductNameDefineMethodStrategy(orderViewModel.OrderProductNameDefineMethodStrategy)
        orderInfo.contractDefineMethodStrategy = mapOrderContractDefineMethodStrategy(orderViewModel.OrderContractDefineMethodStrategy)
        orderInfo.itemQuantityLimitStrategy = mapOrderItemQuantityLimitStrategy(orderViewModel.OrderItemQuantityLimitStrategy)
        orderInfo.customerInn = orderViewModel.CustomerInn;
        orderInfo.customerName = orderViewModel.CustomerName;
        orderInfo.executorInn = orderViewModel.ExecutorInn;
        orderInfo.executorName = orderViewModel.ExecutorName;
        orderInfo.number = orderViewModel.Number
        orderInfo.date = Moment(orderViewModel.Date);
        orderInfo.contractNumber = orderViewModel.ContractNumber;
        orderInfo.contractDate = Moment(orderViewModel.ContractDate);
        orderInfo.expiresOn = Moment(orderViewModel.ExpiresOn);
        orderInfo.deliveryAddress = orderViewModel.DeliveryAddress;
        orderInfo.branch = orderViewModel.BranchId;
        orderInfo.createdOn = Moment(orderViewModel.CreatedOn);
        orderInfo.isCustomerApproved = orderViewModel.IsCustomerApproved;
        orderInfo.customerApprovedOn = orderViewModel.CustomerApprovedOn ? Moment(orderViewModel.CustomerApprovedOn) : null;
        orderInfo.isExecutorApproved = orderViewModel.IsExecutorApproved;
        orderInfo.executorApprovedOn = orderViewModel.ExecutorApprovedOn ? Moment(orderViewModel.ExecutorApprovedOn) : null;
        orderInfo.isExecutorDeclined = orderViewModel.IsExecutorDeclined;
        orderInfo.executorDeclinedOn = orderViewModel.ExecutorDeclinedOn ? Moment(orderViewModel.ExecutorDeclinedOn) : null;
        orderInfo.isReturn = orderViewModel.IsReturn;
        orderInfo.returnNumber = orderViewModel.ReturnNumber;
        orderInfo.returnDate = orderViewModel.ReturnDate ? Moment(orderViewModel.ReturnDate) : null;
        orderInfo.returnInvoiceId = orderViewModel.ReturnInvoiceId;
        orderInfo.returnInvoiceNumber = orderViewModel.ReturnInvoiceNumber;
        orderInfo.returnInvoiceDate = orderViewModel.ReturnInvoiceDate ? Moment(orderViewModel.ReturnInvoiceDate) : null;
        orderInfo.isReturnInvoiceExecutorApproved = orderViewModel.IsReturnInvoiceExecutorApproved;
        orderInfo.isReturnInvoiceCustomerApproved = orderViewModel.IsReturnInvoiceCustomerApproved;
        orderInfo.isStopped = orderViewModel.IsStopped;
        orderInfo.stoppedOn = orderViewModel.StoppedOn ? Moment(orderViewModel.StoppedOn) : null;
        orderInfo.items = _.map(orderViewModel.Items, orderItemViewModel => {
            return mapOrderItem(orderItemViewModel)
        })

        return orderInfo
    }

    return null
}



let mapReturnShipmentItem = item => {
    let shipmentItem = new ReturnShipmentItem()
    shipmentItem.id = item.Id
    shipmentItem.product = item.Product
    shipmentItem.customerCode = item.CustomerCode
    shipmentItem.catalogCode = item.CatalogCode
    shipmentItem.measurement = item.Measurement
    shipmentItem.quantity = item.Quantity
    shipmentItem.price = item.Price
    shipmentItem.total = item.Total
    shipmentItem.ndsRate = item.NdsRate
    shipmentItem.ndsValue = item.NdsValue
    shipmentItem.totalWithNds = item.TotalWithNds
    shipmentItem.orderItem = item.ReturnOrderItem ? mapReturnOrderItem(item.ReturnOrderItem) : null

    return shipmentItem
}

let mapReturnShipment = shipmentViewModel => {
    if (shipmentViewModel) {
        let shipment = new ReturnShipment()

        shipment.id = shipmentViewModel.Id
        shipment.order = mapReturnOrder(shipmentViewModel.ReturnOrder)
        shipment.status = shipmentViewModel.Status
        shipment.number = shipmentViewModel.Number
        shipment.date = shipmentViewModel.Date ? Moment(shipmentViewModel.Date.substr(0, 10), 'YYYY-MM-DD') : null
        shipment.waybillNumber = shipmentViewModel.WaypathBillNumber
        shipment.waybillDate = shipmentViewModel.WaypathBillDate ? Moment(shipmentViewModel.WaypathBillDate.substr(0, 10), 'YYYY-MM-DD') : null
        shipment.contractNumber = shipmentViewModel.ContractNumber
        shipment.contractDate = shipmentViewModel.ContractDate ? Moment(shipmentViewModel.ContractDate.substr(0, 10), 'YYYY-MM-DD') : null
        shipment.createdOn = shipmentViewModel.CreatedOn ? Moment(shipmentViewModel.CreatedOn) : null
        shipment.isAccepted = shipmentViewModel.IsAccepted
        shipment.acceptedOn = shipmentViewModel.AcceptedOn ? Moment(shipmentViewModel.AcceptedOn) : null
        shipment.isDeclined = shipmentViewModel.IsDeclined
        shipment.lastDeclinedOn = shipmentViewModel.LastDeclinedOn ? Moment(shipmentViewModel.LastDeclinedOn) : null
        shipment.total = shipmentViewModel.Total
        shipment.totalInWords = shipmentViewModel.TotalInWords
        shipment.customerInn = shipmentViewModel.CustomerInn
        shipment.customerName = shipmentViewModel.CustomerName
        shipment.consigneeInn = shipmentViewModel.ConsigneeInn
        shipment.consigneeName = shipmentViewModel.ConsigneeName
        shipment.deliveryAddress = shipmentViewModel.DeliveryAddress
        shipment.loadingAddress = shipmentViewModel.LoadingAddress
        shipment.driverName = shipmentViewModel.DriverName
        shipment.carSerial = shipmentViewModel.CarSerialNumber
        shipment.carModel = shipmentViewModel.CarModel
        shipment.isTrailer = shipmentViewModel.IsTrailer
        shipment.isSemiTrailer = shipmentViewModel.IsSemiTrailer
        shipment.trailerSerial = shipmentViewModel.TrailerSerialNumber
        shipment.trailerModel = shipmentViewModel.TrailerModel
        shipment.deliveryDateTime = shipmentViewModel.DeliveryDateTime ? Moment(shipmentViewModel.DeliveryDateTime) : null

        shipment.invoices = shipmentViewModel.ReturnInvoices.map(i => {
            return mapReturnInvoice(i)
        })

        return shipment
    }

    return null
}

let mapReturnShipmentInfo = shipmentViewModel => {
    if (shipmentViewModel) {
        let shipment = new ReturnShipmentInfo()

        shipment.id = shipmentViewModel.Id
        shipment.order = mapReturnOrder(shipmentViewModel.ReturnOrder)
        shipment.status = shipmentViewModel.Status
        shipment.number = shipmentViewModel.Number
        shipment.date = shipmentViewModel.Date ? Moment(shipmentViewModel.Date.substr(0, 10), 'YYYY-MM-DD') : null
        shipment.waybillNumber = shipmentViewModel.WaypathBillNumber
        shipment.waybillDate = shipmentViewModel.WaypathBillDate ? Moment(shipmentViewModel.WaypathBillDate.substr(0, 10), 'YYYY-MM-DD') : null
        shipment.contractNumber = shipmentViewModel.ContractNumber
        shipment.contractDate = shipmentViewModel.ContractDate ? Moment(shipmentViewModel.ContractDate.substr(0, 10), 'YYYY-MM-DD') : null
        shipment.createdOn = shipmentViewModel.CreatedOn ? Moment(shipmentViewModel.CreatedOn) : null
        shipment.isAccepted = shipmentViewModel.IsAccepted
        shipment.acceptedOn = shipmentViewModel.AcceptedOn ? Moment(shipmentViewModel.AcceptedOn) : null
        shipment.isDeclined = shipmentViewModel.IsDeclined
        shipment.lastDeclinedOn = shipmentViewModel.LastDeclinedOn ? Moment(shipmentViewModel.LastDeclinedOn) : null
        shipment.total = shipmentViewModel.Total
        shipment.totalInWords = shipmentViewModel.TotalInWords
        shipment.customerInn = shipmentViewModel.CustomerInn
        shipment.customerName = shipmentViewModel.CustomerName
        shipment.consigneeInn = shipmentViewModel.ConsigneeInn
        shipment.consigneeName = shipmentViewModel.ConsigneeName
        shipment.deliveryAddress = shipmentViewModel.DeliveryAddress
        shipment.loadingAddress = shipmentViewModel.LoadingAddress
        shipment.driverName = shipmentViewModel.DriverName
        shipment.carSerial = shipmentViewModel.CarSerialNumber
        shipment.carModel = shipmentViewModel.CarModel
        shipment.isTrailer = shipmentViewModel.IsTrailer
        shipment.isSemiTrailer = shipmentViewModel.IsSemiTrailer
        shipment.trailerSerial = shipmentViewModel.TrailerSerialNumber
        shipment.trailerModel = shipmentViewModel.TrailerModel
        shipment.deliveryDateTime = shipmentViewModel.DeliveryDateTime ? Moment(shipmentViewModel.DeliveryDateTime) : null
        shipment.items = shipmentViewModel.Items.map(item => {
            return mapReturnShipmentItem(item)
        })

        shipment.invoices = shipmentViewModel.ReturnInvoices.map(i => {
            return mapReturnInvoice(i)
        })

        return shipment
    }

    return null
}


let mapReturnInvoiceItem = item => {
    let invoiceItem = new InvoiceItem()

    invoiceItem.id = item.Id
    invoiceItem.measurement = item.Measurement
    invoiceItem.measurementCode = item.MeasurementCode
    invoiceItem.ndsRate = item.NdsRate
    invoiceItem.ndsValue = item.NdsValue
    invoiceItem.price = item.Price
    invoiceItem.product = item.Product
    invoiceItem.quantity = item.Quantity
    invoiceItem.total = item.Total
    invoiceItem.catalogCode = item.CatalogCode
    invoiceItem.catalogName = item.CatalogName
    invoiceItem.totalWithNds = item.TotalWithNds
    invoiceItem.barcode = item.Barcode
    invoiceItem.lgota = item.LgotaId
    invoiceItem.shipmentItem = item.ReturnShipmentItem ? mapReturnShipmentItem(item.ReturnShipmentItem) : null

    return invoiceItem
}

let mapReturnInvoice = invoiceViewModel => {
    if (invoiceViewModel) {
        let invoice = new Invoice()

        invoice.id = invoiceViewModel.Id
        invoice.number = invoiceViewModel.Number
        invoice.status = invoiceViewModel.Status
        invoice.correctDate = invoiceViewModel.CorrectDate ? Moment(invoiceViewModel.CorrectDate.substr(0, 10), 'YYYY-MM-DD') : null
        invoice.correctDocumentUid = invoiceViewModel.CorrectDocumentUid
        invoice.correctNumber = invoiceViewModel.CorrectNumber
        invoice.date = invoiceViewModel.Date ? Moment(invoiceViewModel.Date.substr(0, 10), 'YYYY-MM-DD') : null
        invoice.contractNumber = invoiceViewModel.ContractNumber
        invoice.contractDate = invoiceViewModel.ContractDate ? Moment(invoiceViewModel.ContractDate.substr(0, 10), 'YYYY-MM-DD') : null
        invoice.createdOn = invoiceViewModel.CreatedOn ? Moment(invoiceViewModel.CreatedOn) : null
        invoice.isCustomerApproved = invoiceViewModel.IsCustomerApproved
        invoice.customerApprovedOn = invoiceViewModel.CustomerApprovedOn ? Moment(invoiceViewModel.CustomerApprovedOn) : null
        invoice.isExecutorApproved = invoiceViewModel.IsExecutorApproved
        invoice.executorApprovedOn = invoiceViewModel.ExecutorApprovedOn ? Moment(invoiceViewModel.ExecutorApprovedOn) : null
        invoice.executorDetails = mapInvoiceMember(invoiceViewModel.ExecutorDetail)
        invoice.customerDetails = mapInvoiceMember(invoiceViewModel.CustomerDetail)
        invoice.total = invoiceViewModel.Total
        invoice.totalInWords = invoiceViewModel.TotalInWords
        invoice.executorDirector = invoiceViewModel.ExecutorDirector
        invoice.executorAccountant = invoiceViewModel.ExecutorAcccountant
        invoice.executorReleaser = invoiceViewModel.ExecutorReleaser
        invoice.customerProxyNumber = invoiceViewModel.CustomerProxyNumber
        invoice.customerProxyDate = invoiceViewModel.CustomerProxyDate ? Moment(invoiceViewModel.CustomerProxyDate.substr(0, 10), 'YYYY-MM-DD') : null
        invoice.customerProxyName = invoiceViewModel.CustomerProxyName
        invoice.shipment = invoiceViewModel.ReturnShipment ? mapReturnShipment(invoiceViewModel.ReturnShipment) : null

        return invoice
    }

    return null
}

let mapReturnInvoiceInfo = invoiceViewModel => {
    if (invoiceViewModel) {
        let invoice = new InvoiceInfo()

        invoice.id = invoiceViewModel.Id
        invoice.number = invoiceViewModel.Number
        invoice.status = invoiceViewModel.Status
        invoice.date = invoiceViewModel.Date ? Moment(invoiceViewModel.Date.substr(0, 10), 'YYYY-MM-DD') : null
        invoice.correctDate = invoiceViewModel.CorrectDate ? Moment(invoiceViewModel.CorrectDate.substr(0, 10), 'YYYY-MM-DD') : null
        invoice.correctDocumentUid = invoiceViewModel.CorrectDocumentUid
        invoice.correctNumber = invoiceViewModel.CorrectNumber
        invoice.contractNumber = invoiceViewModel.ContractNumber
        invoice.contractDate = invoiceViewModel.ContractDate ? Moment(invoiceViewModel.ContractDate.substr(0, 10), 'YYYY-MM-DD') : null
        invoice.createdOn = invoiceViewModel.CreatedOn ? Moment(invoiceViewModel.CreatedOn) : null
        invoice.isCustomerApproved = invoiceViewModel.IsCustomerApproved
        invoice.customerApprovedOn = invoiceViewModel.CustomerApprovedOn ? Moment(invoiceViewModel.CustomerApprovedOn) : null
        invoice.isExecutorApproved = invoiceViewModel.IsExecutorApproved
        invoice.executorApprovedOn = invoiceViewModel.ExecutorApprovedOn ? Moment(invoiceViewModel.ExecutorApprovedOn) : null
        invoice.executorDetails = mapInvoiceMember(invoiceViewModel.ExecutorDetail)
        invoice.customerDetails = mapInvoiceMember(invoiceViewModel.CustomerDetail)
        invoice.total = invoiceViewModel.Total
        invoice.totalInWords = invoiceViewModel.TotalInWords
        invoice.executorDirector = invoiceViewModel.ExecutorDirector
        invoice.executorAccountant = invoiceViewModel.ExecutorAcccountant
        invoice.executorReleaser = invoiceViewModel.ExecutorReleaser
        invoice.customerProxyNumber = invoiceViewModel.CustomerProxyNumber
        invoice.customerProxyDate = invoiceViewModel.CustomerProxyDate ? Moment(invoiceViewModel.CustomerProxyDate.substr(0, 10), 'YYYY-MM-DD') : null
        invoice.customerProxyName = invoiceViewModel.CustomerProxyName
        invoice.shipment = invoiceViewModel.ReturnShipment ? mapReturnShipment(invoiceViewModel.ReturnShipment) : null
        invoice.items = invoiceViewModel.Items.map(item => {
            return mapReturnInvoiceItem(item)
        })

        return invoice
    }

    return null
}


let mapInvoiceItemCatalog = vm => {
    let item = new InvoiceItemCatalog()

    item.id = vm.Id
    item.groupCode = vm.GroupCode
    item.groupNameRu = vm.GroupNameRu
    item.groupNameUz = vm.GroupNameUz
    item.classCode = vm.ClassCode
    item.classNameRu = vm.ClassNameRu
    item.classNameUz = vm.ClassNameUz

    return item
}

export default {
    mapOrderItem: mapOrderItem,
    mapOrder: mapOrder,
    mapOrderInfo: mapOrderInfo,

    mapShipmentItem: mapShipmentItem,
    mapShipment: mapShipment,
    mapShipmentInfo: mapShipmentInfo,

    mapInvoice: mapInvoice,
    mapInvoiceMember: mapInvoiceMember,
    mapInvoiceInfo: mapInvoiceInfo,

    mapReturnOrderItem: mapReturnOrderItem,
    mapReturnOrder: mapReturnOrder,
    mapReturnOrderInfo: mapReturnOrderInfo,

    mapReturnShipmentItem: mapReturnShipmentItem,
    mapReturnShipment: mapReturnShipment,
    mapReturnShipmentInfo: mapReturnShipmentInfo,

    mapReturnInvoiceItem: mapReturnInvoiceItem,
    mapReturnInvoice: mapReturnInvoice,
    mapReturnInvoiceInfo: mapReturnInvoiceInfo,

    mapInvoiceItemCatalog: mapInvoiceItemCatalog
}